import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { PlayerHardwareComponent } from '../../../../../pages/datasets/player-hardware/player-hardware.component';
import { PlayerHardwareEditComponent } from '../../../../../pages/datasets/player-hardware-edit/player-hardware-edit.component';
import { PlayerHardwareDetailsComponent } from '../../../../../pages/datasets/player-hardware-details/player-hardware-details.component';
import { PlayerHardwareDetailsOverviewComponent } from '../../../../../pages/datasets/player-hardware-details/player-hardware-details-overview/player-hardware-details-overview.component';

export const playerHardware: Route = {
  path: 'player-hardware',
  title: 'nav.network.playerHardware',
  data: {
    breadcrumb: 'nav.network.playerHardware',
    icon: SbIcons.playerSetting,
    id: RoutingID.playerHardware,
  },
  children: [
    {
      path: '',
      component: PlayerHardwareComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'player-hardware-edit/:playerHardwareID',
      title: 'nav.datasets.device.hardware.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.device.hardware.edit',
        id: RoutingID.deviceHardwareEdit,
      },
      children: [
        {
          path: '',
          component: PlayerHardwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'player-hardware-create',
      title: 'nav.datasets.device.hardware.create',
      data: {
        breadcrumb: 'nav.datasets.device.hardware.create',
        icon: SbIcons.plus,
        id: RoutingID.deviceHardwareCreate,
      },
      children: [
        {
          path: '',
          component: PlayerHardwareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'player-hardware-details/:playerHardwareID',
      title: 'lang.globals.details',
      data: {
        icon: SbIcons.details,
        breadcrumb: 'lang.globals.details',
        id: RoutingID.playerHardwareDetails,
      },
      children: [
        {
          path: '',
          component: PlayerHardwareDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'player-hardware-overview',
              component: PlayerHardwareDetailsOverviewComponent,
              title: 'lang.globals.overview',
              data: {
                breadcrumb: 'lang.globals.overview',
                icon: SbIcons.eye,
                id: RoutingID.playerHardwareOverview,
              },
            },
            { path: '', redirectTo: RoutingID.playerHardwareOverview, pathMatch: 'full' },
          ],
        },
      ],
    },
  ],
};
